exports.surfaceNets         = require("./lib/surfacenets.js").surfaceNets;
exports.marchingCubes       = require("./lib/marchingcubes.js").marchingCubes;
exports.marchingTetrahedra  = require("./lib/marchingtetrahedra.js").marchingTetrahedra;
